import {
  login as authLogin,
  register as authRegister,
  logout as authLogout,
} from './service/calls';
import { alertActions } from '../actions/Alerts';
import {
  successLogin,
  requestRegister,
  failureRegister,
  successRegister,
  failureLogin,
} from '../actions/AuthActions';
import store from '../store/store';
import { LOGOUT } from '../constants/ActionTypes';

export const register = (user, history) => {
  const userMod = { ...user, username: user.email };
  store.dispatch(requestRegister(userMod));
  authRegister(userMod)
    .then((userResult) => {
      store.dispatch(successRegister(userResult));
      store.dispatch(alertActions.success('Registration successful'));
      setTimeout(() => history.push('/'), 1500);
    })
    .catch((error) => {
      // Error: Request failed with status code 401
      store.dispatch(failureRegister(error.toString()));
      store.dispatch(alertActions.error(error.toString()));
    });
};

///***///
export const login = (username, password) => {
  authLogin({ username, password })
    .then(() => {
      store.dispatch(successLogin(username));
    })
    .catch((error) => {
      store.dispatch(failureLogin(error.toString()));
      store.dispatch(alertActions.error(error.toString()));
    });
};

export const logout = ({ history }) => {
  localStorage.removeItem('user');
  history.push('/');
  return { type: LOGOUT };
};
